export const StatementsByYear = "statementsByYear";
export const ClaimAccount = "claimAccount";
export const Dashboard = "dashboard";
export const Home = "home";
export const AccountsSummary = "accountsSummary";
export const Summary = "summary";
export const InactiveAccountsSummary = "inactiveAccountsSummary";
export const NamedOnboarding = "NamedOnboarding";
export const OnboardingDrivewealthPreenrollment = "OnboardingDrivewealthPreenrollment";
export const CashBalance = "CashBalance";
export const AccountBalances = "accountBalances";
export const ReimburseMe = "reimburseMe";
export const Contribution = "contribution";
export const ContributionPlanner = "contributionPlanner";
export const ContributionPlannerHowItWorks = "contributionPlannerHowItWorks";
export const ContributionsAll = "contributionAll";
export const BalancesInvestmentAccounts = "balancesInvestmentAccounts";
export const InvestmentAccountInfo = "InvestmentAccountInfo";
export const HsabInvestmentAccount = "HsabInvestmentAccount";
export const UmbInvestmentAccount = "UmbInvestmentAccount";
export const MixedInvestmentAccounts = "MixedInvestmentAccounts";
export const Settings = "settings";
export const Resources = "resources";
export const ResourcesDownloadableFiles = "downloadable-files";
export const ResourcesDocuments = "combined-documents";
export const ResourceLinks = "resource-links";
export const ResourcesTaxForms = "tax-forms";
export const ResourcesSecureDocumentUpload = "document-upload";
export const ResourcesFees = "fees";
export const ResourcesFinancialInstitutionTerms = "financial-institution-terms";
export const ResourcesHsaTerms = "hsa-terms";
export const ResourcesHsaInvest = "hsa-invest";
export const ResourcesClosedInvestmentAccounts = "closed-investment-accounts";
export const ResourcesStatements = "statements";
export const PortalRedirect = "portalRedirect";
export const FinancialConnectorRedirect = "FinancialConnectorRedirect";
export const TermsAndConditions = "TermsAndConditions";
export const Privacy = "Privacy";
export const Signup = "Signup";
export const SignupVerifyEmail = "SignupVerifyEmail";
export const LoginInfo = "LoginInfo";
export const UmbSso = "UmbSso";
export const PersonalExpenseTracker = "PersonalExpenseTracker";
export const FeeSchedulePrint = "FeeSchedulePrint";
export const SsoLogout = "SsoLogout";
export const SsoLoginError = "SsoLoginError";
export const LinkedAccountsSettings = "LinkedAccountsSettings";
export const HealthPlanSettings = "HealthPlanSettings";
export const MyProfileSettings = "MyProfileSettings";
export const SsoValidateAccount = "SsoValidateAccount";
export const MyProfileEdit = "MyProfileEdit";
export const MyProfileDisplay = "MyProfileDisplay";
export const UserNotificationPreferences = "UserNotificationPreferences";
export const UserPreferences = "UserPreferences";
export const HsaDebitCards = "HsaDebitCards";
export const HealthcareExpenses = "HealthcareExpenses";
export const HealthcareExpensesUnreviewed = "HealthcareExpensesUnreviewed";
export const HealthcareExpensesUnreimbursed = "HealthcareExpensesUnreimbursed";
export const HealthcareExpensesReimbursed = "HealthcareExpensesReimbursed";
export const HealthcareExpenseClaims = "HealthcareExpenseClaims";
export const HealthcareTerms = "HealthcareTerms";
export const EligibleExpenses = "EligibleExpenses";
export const ViewClaims = "ViewClaims";
export const FindExpenses = "FindExpenses";
export const SamlError = "SamlError";
export const OktaSsoError = "OktaSsoError";
export const EmailVerify = "EmailVerify";
export const OktaEmailVerify = "OktaEmailVerify";
export const InvestmentActivity = "InvestmentAcitivity";
export const InvestmentDocuments = "InvestmentDocuments";
export const DrivewealthBuyInstrumentV2 = "DrivewealthBuyInstrumentV2";
export const DrivewealthSellInstrumentV2 = "DrivewealthSellInstrumentV2";
export const DrivewealthSellInstrumentConfirm = "DrivewealthSellInstrumentConfirm";
export const DrivewealthSellInstrumentConfirmV2 = "DrivewealthSellInstrumentConfirmV2";
export const DrivewealthCreateAccount = "DrivewealthCreateAccount";
export const DrivewealthQuestionnaire = "DrivewealthQuestionnaire";
export const DrivewealthQuestionnaireV2 = "DrivewealthQuestionnaireV2";
export const DrivewealthSweep = "DrivewealthSweep";
export const DrivewealthSweepV2 = "DrivewealthSweepV2";
export const DrivewealthSignupSweep = "DrivewealthSignupSweep";
export const DrivewealthLearnMorePages = "DrivewealthLearnMorePages";
export const DrivewealthChoiceOptionFundsList = "DrivewealthChoiceOptionFundsList";
export const DrivewealthLearnMoreOnboarding = "DrivewealthLearnMoreOnboarding";
export const DrivewealthWizard = "DrivewealthWizard";
export const DrivewealthInvestmentAccountClaims = "DrivewealthInvestmentAccountClaims";
export const DrivewealthPreenrollment = "DrivewealthPreenrollment";
export const DrivewealthPreenrollmentWizard = "DrivewealthPreenrollmentWizard";
export const DrivewealthMultipleAccountSelection = "DrivewealthMultipleAccountSelection";
export const DrivewealthCuratedRtq = "DrivewealthCuratedRtq";
export const DevinirNonCompliantAccountsLandingPage = "DevinirNonCompliantAccountsLandingPage";
export const DocumentSignatureView = "DocumentSignatureView";
export const DocumentView = "DocumentView";
export const InitiateImpersonation = "InitiateImpersonation";
export const ImpersonationError = "ImpersonationError";
export const OktaCredential = "OktaCredential";
export const OktaCredentialVerify = "OktaCredentialVerify";
export const BiometricAuthSettings = "BiometricAuthSettings";
export const FlaggingDebug = "FlaggingDebug";
export const HsabAccountSelection = "HsabAccountSelection";
export const WexRedirect = "WexRedirect";
export const EbtoClaim = "EbtoClaim";
export const EbtoVerificationCode = "EbtoVerificationCode";
export const EbtoGeneralInformation = "EbtoGeneralInformation";
export const EbtoPricingOffer = "EbtoPricingOffer";
export const EbtoRetained = "EbtoRetained";
export const EbtoTransferProcess = "EbtoTransferProcess";
export const EbtoESignature = "EbtoESignature";
export const EbtoTransferOutComplete = "EbtoTransferOutComplete";
export const ProductScanner = "ProductScanner";
export const HsabNotionalDashboard = "HsabNotionalDashboard";
export const OktaSso = "OktaSso";
export const NotionalAccount = "NotionalAccount";
export const SecureDocumentUpload = "SecureDocumentUpload";
export const HsabExpenseManagement = "HsabExpenseManagement";
export const HsabExpenseManagementSubmitted = "submitted";
export const HsabExpenseManagementAvailable = "available";
export const ContributionsEdit = "ContributionsEdit";
export const ManagePayrollContributions = "ManagePayrollContributions";
export const ContributionsManageOtherHsaAmounts = "ContributionsManageOtherHsaAmounts";
export const ConfirmContribution = "ConfirmContribution";
export const DistributionSchedules = "DistributionSchedules";
export const DrivewealthDisclosures = "DrivewealthDisclosures";
export const DrivewealthW9 = "DrivewealthW9";
export const DebitCardManagement = "DebitCardManagement";
export const MessageCenter = "MessageCenter";
export const OnboardingBalanceTransfer = "OnboardingBalanceTransfer";
export const OnboardingLinkedAccounts = "OnboardingLinkedAccounts";
export const OnboardingContribution = "OnboardingContribution";
export const OnboardingScheduleContribution = "OnboardingScheduleContribution";
export const OnboardingConfirmContributionPage = "OnboardingConfirmContributionPage";
export const OnboardingContributionScheduledMessage = "OnboardingContributionScheduledMessage";
export const UnsupportedBrowser = "UnsupportedBrowser";
